import { create } from 'zustand'
import { createJSONStorage, devtools, persist } from 'zustand/middleware'

interface IUserSettingsStore {
  browserId: string

  isDebugMode: boolean
  setIsDebugMode: (isDebugMode: boolean) => void

  isSeenAskLlmPopover: boolean
  setIsSeenAskLlmPopover: (seenNewFeaturePopovers: boolean) => void
}
const useUserSettingsStore = create<IUserSettingsStore>()(
  devtools(
    persist(
      (set) => ({
        // Assigns a random UUID on store init if not already present
        browserId: crypto.randomUUID(),
        isDebugMode: false,
        setIsDebugMode: (isDebugMode: boolean) => {
          set({ isDebugMode: isDebugMode })
        },
        isSeenAskLlmPopover: false,
        setIsSeenAskLlmPopover: (isSeenAskLlmPopover: boolean) => {
          set({ isSeenAskLlmPopover: isSeenAskLlmPopover })
        },
      }),
      {
        name: 'pair-search-user-settings-store',
        storage: createJSONStorage(() => localStorage),
        version: 1,
      },
    ),
  ),
)

export function useBrowserId() {
  return useUserSettingsStore((state) => state.browserId)
}

export function useDebugMode() {
  const isDebugMode = useUserSettingsStore((state) => state.isDebugMode)
  const setIsDebugMode = useUserSettingsStore((state) => state.setIsDebugMode)

  return {
    isDebugMode,
    setIsDebugMode,
  }
}

export function useSeenAskLlmPopover() {
  const isSeenAskLlmPopover = useUserSettingsStore(
    (state) => state.isSeenAskLlmPopover,
  )
  const setIsSeenAskLlmPopover = useUserSettingsStore(
    (state) => state.setIsSeenAskLlmPopover,
  )

  return {
    isSeenAskLlmPopover,
    setIsSeenAskLlmPopover,
  }
}
